<template>
    <app-layout ref="lo" title="Penyedia">
        <template #header>
            <BreadCrumb :breadcrumb="$page.props.bc" />
        </template>

        <div class="py-4">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg">
                    <section class="text-gray-600 body-font">
                        <div class="container px-5 py-5 mx-auto">
                            <div class="flex flex-wrap w-full mb-5 flex-col">

<!--                                    <input type="hidden"  v-model="form.id" id="id">-->
                                <Accordion :multiple="true" :activeIndex="[0]">
                                    <AccordionTab header="Data DRM" :disabled="true">
                                        <div class="">
                                            <div class="field w-full px-3 mb-3">

<!--                                                <ButtonShow @click="visible1 = true" />-->
<!--                                                <Dialog v-model:visible="visible1" modal :style="{ width: '50vw' }">-->
                                                    <pdf v-bind:src="'/storage/'+handleHashing('drm')+'/'+daftarRekanMampu.file_sk_drm" />
<!--                                                </Dialog>-->
                                            </div>

                                        </div>
                                    </AccordionTab>
                                    <AccordionTab header="Data Rekanan" >
                                        <div class="">
                                            <div class="form-group">
                                                <ConfirmDialog></ConfirmDialog>
                                                <DataTable :value="detailRekanMampu" tableStyle="min-width: 50rem">
                                                    <Column v-for="col of columns" :key="col.field" :field="col.field" :header="col.header"></Column>
<!--                                                    <Column field="id" header="aksi" :sortable="true">-->
<!--                                                        <template #body="slotProps">-->

<!--                                                            <ButtonDelete label="hapus" @click="deletePenyediaPegawai(slotProps.data)" />-->
<!--                                                        </template>-->
<!--                                                    </Column>-->
                                                </DataTable>
                                            </div>
                                        </div>
                                    </AccordionTab>

                                </Accordion>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
import { defineComponent } from "vue";
import AppLayout from "@/Layouts/AppLayout";
import BreadCrumb from "@/Components/BreadCrumb";
import JetLabel from "@/Jetstream/Label";
import Input from "@/Components/Input.vue";
import InputError from "@/Components/InputError.vue";
import ButtonSave from "@/Components/ButtonSave.vue";
import InputRepeaterPegawai from "@/Pages/Penyedia/InputRepeaterPegawai.vue";
import InputRepeaterKontrak from "@/Pages/Penyedia/InputRepeaterKontrak.vue";
import InputRepeaterBarang from "@/Pages/Penyedia/InputRepeaterBarang.vue";
import InputRepeaterKbli from "@/Pages/Penyedia/InputRepeaterKbli.vue";
import InputMask from 'primevue/inputmask';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import FileUpload from 'primevue/fileupload';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import ButtonShow from "@/Components/ButtonShow";
import Button from 'primevue/button';
import ButtonDelete from "@/Components/ButtonDelete";
import pdf from 'pdfvuer';
import Dialog from 'primevue/dialog';
import ConfirmDialog from 'primevue/confirmdialog';
import ConfirmPopup from 'primevue/confirmpopup';
import md5Hex from "md5-hex";



export default defineComponent({
    components: {
        AppLayout,
        BreadCrumb,
        JetLabel,
        Input,
        InputError,
        ButtonSave,
        InputRepeaterPegawai,
        InputRepeaterKontrak,
        InputRepeaterBarang,
        InputRepeaterKbli,
        InputMask,
        Accordion,
        AccordionTab,
        FileUpload,
        DataTable,
        Column,
        ButtonShow,
        pdf,
        Dialog,
        ButtonDelete,
        ConfirmDialog,
        ConfirmPopup,

    },
    props: {
            penyedia : Array,
            daftarRekanMampu : Array,
            detailRekanMampu : Array,
        },
    data() {
        return {

            visible1: false,
            columns :[
                { field: 'penyedia.nama_perusahaan', header: 'Nama Perusahaan' },
                { field: 'penyedia.npwp_perusahaan', header: 'NPWP Perusahaan' },
                { field: 'penyedia.nama_pemberi_kuasa', header: 'Nama Direktur' },
                // { field: 'id', header: 'status' },
            ],


                // Confirm : useConfirm(),

        };
    },
    mounted(){

    },
    methods: {

        handleHashing(data) {
            this.hashedMessage = md5Hex(data);
            // console.log(md5Hex(data));
            return this.hashedMessage;
        },
    },
});
</script>
